import "../pages.scss";
import { VisitasState } from "../../context/visitas/VisitasState";
import Datatable from "./visitasTable/Datatable";
const VisitasPage = () => {
  return (
    <VisitasState>
      <Datatable />
    </VisitasState>
  );
};

export default VisitasPage;